<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500 align-top">
      <RouterLink
        :to="{
          name: 'accounts.smsCampaigns.smsCampaignId',
          params: {
            accountId: smsCampaign.account_id,
            smsCampaignId: smsCampaign.id,
          },
        }"
      >
        {{ smsCampaign.sms_message.content }}
      </RouterLink>

      <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ smsCampaign.phone_numbers_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Unique Recipients</dt>
        </div>

        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ smsCampaign.phone_numbers_sent_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Sent</dt>
        </div>

        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ smsCampaign.phone_numbers_failed_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Failed</dt>
        </div>
      </dl>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-left align-top">
      {{ status }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-left align-top">
      <span v-if="startsAt && smsCampaign.status === 'PENDING'">{{ startsAt }}</span>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right align-top">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
    <td class="w-0 align-top p-4">
      <MoreAction
        v-if="$membershipHasPermissionTo('delete sms campaigns')"
        :sms-campaign="smsCampaign"
        @deleted="$emit('deleted')"
      />
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import { capitalize } from 'lodash-es';
import MoreAction from './MoreAction.vue';

export default {
  components: {
    MoreAction,
  },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      const { status = '' } = this.smsCampaign;

      return status ? capitalize(status) : 'N/A';
    },
    startsAt() {
      if (!this.smsCampaign.starts_at) {
        return null;
      }

      return moment.utc(this.smsCampaign.starts_at).local().format('DD-MM-YYYY HH:mm');
    },
    createdAt() {
      return moment.utc(this.smsCampaign.created_at).local().format('DD-MM-YYYY HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.smsCampaign.created_at).local().fromNow();
    },
  },
};
</script>
